import type { Unit } from '../../types/api';
import type { MapPropertyTooltipData } from './WorldMap';

const DEFAULT_PROPERTY_IMAGE = '/images/bg-wide2.jpg';

export function buildMapPropertyFromUnit(unit: Unit): MapPropertyTooltipData {
  const title = unit.address || unit.city || `Unit ${unit.unit_id_no}`;
  const locationLabel = [unit.city, unit.country].filter(Boolean).join(', ');
  const description =
    unit.remark ||
    (unit.unit_type && locationLabel
      ? `${unit.unit_type} in ${locationLabel}.`
      : locationLabel || undefined);

  return {
    unitId: unit.unit_id_no,
    imageUrl: `/images/unit-${unit.unit_id_no}.jpg`,
    fallbackImageUrl: DEFAULT_PROPERTY_IMAGE,
    unitType: unit.unit_type,
    title,
    country: unit.country,
    currency: unit.currency,
    operatingModel: unit.operating_model,
    description,
  };
}
